export default __webpack_public_path__ + "static/media/analytics.47b371ea.svg";